<div class="modal-header primaryBgColor grayFontColor">
    <h5 class="modal-title">Eltern anlegen</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <span ngbAutofocus tabindex="-1"></span>
    <div class="container-fluid">
        <div class="form-group my-4 my-lg-2" *ngFor="let line of fields1">
            <app-input [(val)]="eltern[line.key]" [name]="line.label" [tooltip]="line.label" [required]="line.pflichtfeld"
                       [placeholder]="" [type]="line.type" [noData]="line.noData"></app-input>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn scButton" (click)="activeModal.dismiss()">Abbrechen</button>
    <button class="btn pcButton" (click)="save()">Anlegen</button>
</div>
